import { render, staticRenderFns } from "./RemoveGroupUser.vue?vue&type=template&id=2b50b0d8&scoped=true"
import script from "./RemoveGroupUser.vue?vue&type=script&lang=js"
export * from "./RemoveGroupUser.vue?vue&type=script&lang=js"
import style0 from "./RemoveGroupUser.vue?vue&type=style&index=0&id=2b50b0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50b0d8",
  null
  
)

export default component.exports